import '@/styles/global.scss'
import type { AppProps } from 'next/app'
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react'

import { rollbarConfig } from '@/services/rollbar'


export default function App({ Component, pageProps }: AppProps) {
  return (
    <RollbarProvider config={rollbarConfig}>
      <ErrorBoundary>
        <Component {...pageProps} />
      </ErrorBoundary>
    </RollbarProvider>
  )
}
